import fetch from '../../utils/fetch'

export function getMercantCouponList(params) {
    return fetch({
        url: '/api/ticket/mercantCouponList',
        method: 'POST',
        data: params
    })
}

